export default __webpack_public_path__ + "static/media/marie.c28f3266.jpg";